import { useLang } from "../../lib/i18n";

const fmt = (v, unit) => (v == null ? "—" : `${v}${unit}`);

export const ResultBadge = ({ result }) => {
  const { t } = useLang();
  const pass = result !== "fail";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 font-mono text-[11px] uppercase tracking-wider ${pass ? "bg-emerald-400/15 text-emerald-300" : "bg-red-400/15 text-red-300"}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${pass ? "bg-emerald-400" : "bg-red-400"}`} />{pass ? t("rep.pass") : t("rep.fail")}
    </span>
  );
};

export const ReportsTable = ({ rows, names, dateFmt }) => {
  const { t } = useLang();
  const cols = [t("rep.batch"), t("rep.date"), t("rep.product"), t("rep.moisture"), t("rep.ash"), t("rep.gcv"), t("rep.density"), t("rep.fines"), t("rep.lab"), t("rep.result")];
  return (
    <div className="hidden md:block overflow-x-auto rounded-[24px] border hairline bg-[var(--forest-2)]/80 backdrop-blur-xl">
      <table data-testid="reports-table" className="w-full text-sm">
        <thead>
          <tr className="text-left">{cols.map((c) => <th key={c} className="px-4 py-4 font-mono text-[11px] uppercase tracking-wider text-[var(--sage)] font-normal whitespace-nowrap">{c}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} data-testid={`report-row-${r.batch_no}`} className="border-t hairline hover:bg-white/[0.03] transition-colors">
              <td className="px-4 py-4 font-mono text-[var(--husk)] whitespace-nowrap">{r.batch_no}</td>
              <td className="px-4 py-4 whitespace-nowrap">{dateFmt(r.test_date)}</td>
              <td className="px-4 py-4 whitespace-nowrap">{names[r.product_slug] || r.product_slug}</td>
              <td className="px-4 py-4">{fmt(r.moisture_pct, "%")}</td>
              <td className="px-4 py-4">{fmt(r.ash_pct, "%")}</td>
              <td className="px-4 py-4 whitespace-nowrap">{fmt(r.gcv_kcal, " kcal/kg")}</td>
              <td className="px-4 py-4 whitespace-nowrap">{fmt(r.density_kg_m3, " kg/m³")}</td>
              <td className="px-4 py-4">{fmt(r.fines_pct, "%")}</td>
              <td className="px-4 py-4 text-[var(--sage)]">{r.lab || "—"}</td>
              <td className="px-4 py-4"><ResultBadge result={r.result} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const ReportCards = ({ rows, names, dateFmt }) => {
  const { t } = useLang();
  return (
    <div className="md:hidden grid gap-3">
      {rows.map((r) => (
        <article key={r.id} data-testid={`report-card-${r.batch_no}`} className="rounded-[20px] border hairline bg-[var(--forest-2)]/90 p-5">
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="font-mono text-sm text-[var(--husk)]">{r.batch_no}</p>
              <p className="text-sm text-[var(--sage)]">{dateFmt(r.test_date)} · {names[r.product_slug] || r.product_slug}</p>
            </div>
            <ResultBadge result={r.result} />
          </div>
          <dl className="mt-4 grid grid-cols-3 gap-3 text-sm">
            {[[t("rep.moisture"), fmt(r.moisture_pct, "%")], [t("rep.ash"), fmt(r.ash_pct, "%")], [t("rep.gcv"), fmt(r.gcv_kcal, "")], [t("rep.density"), fmt(r.density_kg_m3, "")], [t("rep.fines"), fmt(r.fines_pct, "%")], [t("rep.lab"), r.lab || "—"]].map(([k, v]) => (
              <div key={k}><dt className="font-mono text-[11px] uppercase text-[var(--sage)]">{k}</dt><dd className="mt-0.5 break-words">{v}</dd></div>
            ))}
          </dl>
        </article>
      ))}
    </div>
  );
};
